import styled from 'styled-components';

export default styled.nav`
  > div {
    background-color: ${({ theme }) => theme.palette.colorPrimary};
    border-bottom: 0.4em solid
      ${({ theme }) => theme.palette.colorSecondaryFirst};
    display: flex;
    justify-content: space-between;
  }

  img {
    margin: 0;
    top: 0.1em;
    padding: 0;
    position: absolute;
    height: 2em;
  }
  a {
    text-decoration: none;
    padding: 0.6em;
    color: white;
    display: block;
    &:hover {
      opacity: 0.8;
    }
  }
  ul {
    display: inline-block;
    margin: 0;
    li {
      position: relative;
      text-decoration: none;
      text-transform: uppercase;
      display: inline-block;
      box-sizing: border-box;
      ul {
        transition: opacity 0.5s ease;
        background-color: ${({ theme }) => theme.palette.colorPrimary};
        position: absolute;
        z-index: 99999;
        display: block;
        overflow: hidden;
        opacity: 0;
        height: 0;
        right: 0;
        padding: 0;
        li {
          min-width: 200px;
          display: block;
          text-align: right;
          a,
          button {
            font-size: inherit;
            text-align: right;
            display: block;
            border: none;
            cursor: pointer;
            background-color: none;
          }
        }
      }
      &:hover {
        ul {
          opacity: 1;
          height: auto;
          overflow: auto;
        }
      }
    }
  }
`;
